import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { Control } from "react-hook-form";
import type { UserSourceCreateRequest } from "../../types";

type SubjectClaimFormFieldProps = {
  control: Control<UserSourceCreateRequest>;
};

export function SubjectClaimFormField({ control }: SubjectClaimFormFieldProps) {
  return (
    <FormField
      control={control}
      name="subject_claim"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            Subject Claim
            <span className="text-destructive"> *</span>
          </FormLabel>
          <FormControl>
            <Input {...field} />
          </FormControl>
          <FormDescription>
            The JWT claim used as the user identifier. Defaults to{" "}
            <code className="font-mono text-xs">sub</code>.
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
